import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';
import { NavigationService } from '../core/services/navigation.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private sessionStorageService: SessionStorageService,
    private navigationService: NavigationService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(error => {
      if (error.error && error?.error['errorCode'] === 'SystemMaintenance_400') {
        this.sessionStorageService.setItem('maintenanceMsg', error.error['detail']);
        this.navigationService.navigate(['maintenance']);
        return EMPTY;
      }

      return throwError(error);
    }));
  }
}
